import { Component, Input } from '@angular/core';

import { CheckListComponent } from '@atoms/check-list/check-list.component';
import { CheckListItemComponent } from '@atoms/check-list/check-list-item/check-list-item.component';
import { ShowMoreComponent } from '@atoms/show-more/show-more.component';
import { ShowMoreItemComponent } from '@atoms/show-more/show-more-item/show-more-item.component';
import { FirstCapitalPipe } from '@pipes/first-capital.pipe';
import { CarEquipmentFinalItem } from '@models/car.model';

@Component({
  selector: 'app-car-detail-equipment-list',
  imports: [CheckListComponent, CheckListItemComponent, ShowMoreComponent, ShowMoreItemComponent, FirstCapitalPipe],
  templateUrl: './car-detail-equipment-list.component.html',
  styleUrl: './car-detail-equipment-list.component.scss',
})
export class CarDetailEquipmentListComponent {
  @Input() category?: CarEquipmentFinalItem;
}
